module.exports = __webpack_public_path__ + "static/img/10.ff2b776.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/eng/10.png
// module id = YwVZ
// module chunks = 0